



























































































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';

const cssPrefix = 'firmware_Tab';

@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class ProductFirmware extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  firmwareList: any = {};
  latestFirmware: any = [];
  termsandconditionsmessage: string = '';
  selectedFirmware: any = {};
  showTNCDialogFlag: boolean = false;
  browseAllFirmware: boolean = false;
  emptyFirmware: boolean = false;
  currentVersionExpanded :boolean = true;
  avaliableSoftwareExpanded: boolean = true;
  additionalSoftwareExpanded:boolean = true;
  configs: any = [];
  mounted() {
    this.firmwareList.currentVersion === undefined && this.getFirmwareList();
  }
  redirectToFirmware() {
    window.open('https://www.sonicwall.com/support/product-lifecycle-tables/#software-and-firmware-release-model', '_blank');
  }
  getFirmwareList() {
    this.$store
      .dispatch('MswProductsStoreModule/getFirmwareList', {
        serialNumber: this.serialNumber,
        languageCode: 'EN',
        appName: 'MSW',
        oemCode: 'SNWL',
      })
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.$store.commit('MswProductsStoreModule/setSkipLoading', 'NO');
      if ((res.msgCode === 'MSWAPP:NODOWMLOADS' || res.content === undefined)
        || (res.content.previousDownloads === undefined && res.content.availableDownloads === undefined)) {
        this.emptyFirmware = true;
        return;
      }
      const { availableDownloads, currentVersion, previousDownloads } = res?.content;
      if (availableDownloads) {
        this.firmwareList.availableDownloads = ([...this.getModifiedFirmwareList(availableDownloads)]);
      }
      if (currentVersion) {
        this.firmwareList.currentVersion = ([...this.getModifiedFirmwareList(currentVersion)]);
      }
      if (previousDownloads) {
        this.firmwareList.previousDownloads = ([...this.getModifiedFirmwareList(previousDownloads)]);
      }
      this.configs = [];
      if (this.firmwareList.availableDownloads !== undefined) {
        this.latestFirmware = this.firmwareList.availableDownloads
        .filter((element: any) => element.isLatest === 'YES');
        /*if (this.configs.length === 0 && this.latestFirmware && this.latestFirmware.length > 0 &&
           this.firmwareList.currentVersion !== undefined) {
          if (this.latestFirmware[0].version !== this.firmwareList.currentVersion[0].version) {
            this.configs.push({
              name: 'Available Downloads',
              data: this.firmwareList.availableDownloads,
              opened: true,
            });
            if (this.firmwareList.previousDownloads !== undefined && this.firmwareList.previousDownloads.length > 0) {
              this.configs.push({
                name: 'Previous Downloads',
                data: this.firmwareList.previousDownloads,
                opened: true,
              });
            }
          }
        }
      }
      if (this.latestFirmware.length <= 0 && this.firmwareList.previousDownloads !== undefined) {
        this.latestFirmware = this.firmwareList.previousDownloads
        .filter((element: any) => element.isLatest === 'YES');
        if (this.configs.length === 0 && this.latestFirmware && this.firmwareList.currentVersion !== undefined) {
          if (this.latestFirmware[0].version !== this.firmwareList.currentVersion[0].version) {
            this.configs.push({
              name: 'Previous Downloads',
              data: this.firmwareList.previousDownloads,
              opened: true,
            });
            if (this.firmwareList.availableDownloads !== undefined && this.firmwareList.availableDownloads.length > 0) {
              this.configs.push({
                name: 'Available Downloads',
                data: this.firmwareList.availableDownloads,
                opened: true,
              });
            }
          }
        }*/
      }
      if (this.configs.length === 0) {
        if (this.firmwareList.availableDownloads !== undefined && this.firmwareList.availableDownloads.length > 0) {
          this.configs.push({
            name: this.$t('products.availableDownloads')
                  .toString(),
            data: this.firmwareList.availableDownloads,
            opened: true,
          });
        }
        if (this.firmwareList.previousDownloads !== undefined && this.firmwareList.previousDownloads.length > 0) {
          this.configs.push({
            name: this.$t('products.previousDownloads')
                  .toString(),
            data: this.firmwareList.previousDownloads,
            opened: true,
          });
        }
      }
    });
  }
  getModifiedFirmwareList(data: any) {
    const modifiedFirmwareList = data?.map((firmware: any) => {
      const { firmwareEndDate, firmwareStatus, softwareList: softwareListToBeModified, ...availableDownloads } = firmware;
      const softwareList = softwareListToBeModified?.map((list: any) =>  {
        return { ...list, firmwareEndDate , firmwareStatus };
      });
      return { ...availableDownloads, firmwareEndDate, firmwareStatus, softwareList };
    });
    return modifiedFirmwareList;
  }
  showTnCDialog(software: any) {
    this.selectedFirmware = {};
    this.selectedFirmware = { ...software };
    this.showTNCDialogFlag = true;
    const request = {
      swId: this.selectedFirmware.softwareID || 0,
      tncId: this.selectedFirmware.TNCID || 0,
    };
    this.$store
      .dispatch('MswProductsStoreModule/getTermsAndConditions', request)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
        this.termsandconditionsmessage = res.hasOwnProperty('content') ?
          res.content.hasOwnProperty('termsNConditions') ? res.content.termsNConditions : '' : '';
        if (this.termsandconditionsmessage !== '') {
          this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&lt;/g, '<');
          this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&gt;/g, '>');
          this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&lt;/g, '/>');
        }
      }
    })
    .catch((errResponse: any) => {
      console.warn(errResponse);
      this.$store.commit('stopLoading');
    });
  }
  downloadFile() {
    if (this.selectedFirmware && this.selectedFirmware !== undefined) {
      this.downloadSoftware(this.selectedFirmware.softwareID, this.selectedFirmware.softwareGroupID, this.selectedFirmware.isRNotes);
    }
    this.closeDialog();
  }
  downloadSoftware(softwareId: string, softwareGroupId: string, isRNote: string) {
    // const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const userId = this.$store.getters.getUserId;
    const payload = { username:userId, swID:softwareId, swGrpID: softwareGroupId, isRNotes: isRNote, appName:'MSW', oemCode:'SNWL' };
    this.$store.dispatch(
      'DownloadCenterStoreModule/downloadSoftware', payload,
    )
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        window.open(resp.content.downloadUrl);
      }
    })
    .catch((errorRes: any) => {
      console.error(errorRes.message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  closeDialog() {
    this.showTNCDialogFlag = false;
  }
  onSoftwareExpanded(softwareName: string) {
    this.configs.map((ele: any) => {
      if (ele.name === softwareName) {
        ele.opened = ele.opened === true ? false : true;
      }
    });
  }
}
